import React, { useEffect, useState } from "react";
import "./Library.css"; // We'll define our styles here

function Library() {
  const [access, setAccess] = useState(false);

  function getCookie(name) {
    const nameEQ = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const parts = decodedCookie.split(";");
    for (let i = 0; i < parts.length; i++) {
      let part = parts[i].trim();
      if (part.indexOf(nameEQ) === 0) {
        return part.substring(nameEQ.length, part.length);
      }
    }
    return null;
  }

  useEffect(() => {
    var name = getCookie("kungfu");

    if (name) {
      setAccess(true);
    }
  }, []);

  return (
    <div className="content-container resources-page">
      {access ? (
        <>
          <h1>EBM Private Form Library</h1>
          Disclaimer: This webpage is unlisted and intended solely for a select
          group of trusted students. Please do not share this link with anyone
          else. If the link is circulated beyond this group, we will have to
          revoke access.
          <ul className="styled-list">
            <li>Northern Shaolin 北少林</li>
            <ul>
              <li>Tan Tui 弹腿 Solo forms - 12 rows</li>
              <ul>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=dbJAUQ1B5tc"
                    target="whole"
                  >
                    {" "}
                    Row 1
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=aU_Vy86QT5k"
                    target="whole"
                  >
                    {" "}
                    Row 2
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=cqQ9fccQxlk"
                    target="whole"
                  >
                    {" "}
                    Row 3
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=T47-J9XCJS0"
                    target="whole"
                  >
                    {" "}
                    Row 4
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=AdR9qMf2T-4"
                    target="whole"
                  >
                    {" "}
                    Row 5
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=CkkZ1nIf9ag"
                    target="whole"
                  >
                    {" "}
                    Row 6
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=LiXy9GBcJ2E"
                    target="whole"
                  >
                    {" "}
                    Row 7
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=tNx3o3FQbcE"
                    target="whole"
                  >
                    {" "}
                    Row 8
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=_dw8THMsf_8"
                    target="whole"
                  >
                    {" "}
                    Row 9
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=MJKDQCA8GY0"
                    target="whole"
                  >
                    {" "}
                    Row 10
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=XuYlk_Eg5JU"
                    target="whole"
                  >
                    {" "}
                    Row 11
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=QYcUdPCRpE0"
                    target="whole"
                  >
                    {" "}
                    Row 12
                  </a>
                </li>
              </ul>

              <li>Tan Tui 弹腿 Fighting Drills (two person drills) </li>
              <ul>
                <li>
                  <a href="https://youtu.be/KAMSEnixJ9o?" target="whole">
                     Row 1 
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/KAMSEnixJ9o?t=33" target="whole">
                     Row 2 
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/KAMSEnixJ9o?t=61" target="whole">
                     Row 3 
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/KAMSEnixJ9o?t=95" target="whole">
                     Row 4 
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/KAMSEnixJ9o?t=130?" target="whole">
                     Row 5 
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/KAMSEnixJ9o?t=160" target="whole">
                     Row 6 
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/KAMSEnixJ9o?t=192" target="whole">
                     Row 7 
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/KAMSEnixJ9o?t=220" target="whole">
                     Row 8 
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/KAMSEnixJ9o?t=254" target="whole">
                     Row 9 
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/KAMSEnixJ9o?t=282" target="whole">
                     Row 10 
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/KAMSEnixJ9o?t=315" target="whole">
                     Row 11 
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/KAMSEnixJ9o?t=345" target="whole">
                     Row 12 
                  </a>
                </li>
              </ul>
            </ul>

            <ul>
              <li>Intermediate Forms</li>
              <ul>
                <li>
                  <a href="https://youtu.be/P7QSwqS5VdI" target="whole">
                    Lien Bo
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/E8qCIRefR9o" target="whole">
                    Sui Wan
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/-0V750f4B5A" target="whole">
                    Praying Mantis
                  </a>
                </li>
              </ul>

              <li>Northern Shaolin Core 10 Forms</li>
              <ul>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=JP3RXAmw3Vk"
                    target="whole"
                  >
                    {" "}
                    Shaolin 1 (8) Enter The Gate 開門
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=tOValFbq2NE"
                    target="whole"
                  >
                    {" "}
                    Shaolin 2 (7) Lead the Way 領路{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=ey0LWJsGmmY"
                    target="whole"
                  >
                    {" "}
                    Shaolin 3 (6) Horse Riding 坐馬{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=aYSJK_KMG-8"
                    target="whole"
                  >
                    {" "}
                    Shaolin 4 (5) Pierce the Heart 穿心
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=Upfr7j-TqAQ"
                    target="whole"
                  >
                    {" "}
                    Shaolin 5 (3) Martial Practice 武藝
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=uvqE_n-gNXE"
                    target="whole"
                  >
                    {" "}
                    Shaolin 6 (1) Close Combat 短打
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=JdBOM0tdUMM"
                    target="whole"
                  >
                    {" "}
                    Shaolin 7 (2) Plum Blossom 梅花{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=r_-Lvvyy-YM"
                    target="whole"
                  >
                    {" "}
                    Shaolin 8 (4) Uprooting Step 拔歩
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=LwenoYqOD5Q"
                    target="whole"
                  >
                    {" "}
                    Shaolin 9 (8) Chain of Rings 連環
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=lGmhb95CbGY"
                    target="whole"
                  >
                    {" "}
                    Shaolin 10 (10) The Method 式法
                  </a>
                </li>
              </ul>

              <li>Weapons Forms</li>

              <ul>
                <li>Staff</li>
                <ul>
                  <li>
                    <a href="https://youtu.be/aJ-QQtrVYYs" target="whole">
                      Shaolin 72 technique staff{" "}
                    </a>
                  </li>
                  <li>
                    <a href="https://youtu.be/OiFs2GiMnSI" target="whole">
                      Shaolin Water & Fire Fighting Staff
                    </a>{" "}
                    (two person form)
                  </li>
                </ul>
                <li>Spear</li>
                <ul>
                  <li>
                    <a href="https://youtu.be/Xxn2Ezoc1ig" target="whole">
                      Shaolin Rising Block Spear
                    </a>
                  </li>
                  <li>
                    <a href="https://youtu.be/gQOJ3Vg0kSI" target="whole">
                      Shaolin Plum Blossom Spear
                    </a>
                  </li>
                </ul>
                <li>Broadsword (single edge)</li>
                <ul>
                  <li>
                    <a href="https://youtu.be/MtPsmtP5Y4k" target="whole">
                      Shaolin Pa Kua Do Eight Direction Saber
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/watch?v=GNz-XCrCdHE"
                      target="whole"
                    >
                      Wu Tang Saber Form - Riding the Wind
                    </a>
                  </li>
                  <li>
                    <a href="https://youtu.be/R4WxCjuExIU" target="whole">
                      Shaolin Plum Flower Ground Rolling Double Saber
                    </a>
                  </li>
                </ul>
                <li>Straight Sword (double edge)</li>
                <ul>
                  <li>
                    <a href="https://youtu.be/541oUcoS6Bw" target="whole">
                      Wu Tang Double Sword{" "}
                    </a>
                  </li>
                  <li>
                    <a href="https://youtu.be/kRtzwxpMSho" target="whole">
                      Wu Tang Dragon Phoenix Sword{" "}
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/watch?v=SQTb6Vg6jgE"
                      target="whole"
                    >
                      Wu Tang Green Dragon Sword
                    </a>
                  </li>
                </ul>
                <li>Hook Swords</li>
                <ul>
                  <li>
                    <a href="https://youtu.be/_2eWvWGvsu8" target="whole">
                      Shaolin Tiger Head Hook Swords
                    </a>
                  </li>
                </ul>
                <li>Kwan Dao</li>
                <ul>
                  <li>
                    <a href="https://youtu.be/CgQhhHreC5g" target="whole">
                      Shaolin Spring Autumn Kwan Dao
                    </a>
                  </li>
                </ul>
              </ul>
              <li>Additional Shaolin Forms</li>
              <ul>
                <li>
                  <a href="https://youtu.be/vPfzovkwPWU?t=7" target="whole">
                    Lohan 1
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/vPfzovkwPWU?t=70" target="whole">
                    Lohan 2
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/vPfzovkwPWU?t=186" target="whole">
                    Lohan 3
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/vPfzovkwPWU?t=270" target="whole">
                    Lohan 4
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/R_poCjdnXTA" target="whole">
                    Lok Hop (Six Harmonies)
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=Z_hiZ9WhctI"
                    target="whole"
                  >
                    Cha Chuan
                  </a>
                </li>
              </ul>

              <li>Five Animals of Shaolin (old school)</li>
              <ul>
                <li>
                  <a href="https://youtu.be/rx3X7kgPTQ4" target="whole">
                    Five Animals of Shaolin - Leopard
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/5SVZxdU819g" target="whole">
                    Five Animals of Shaolin - Snake
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/Aep9RgKrVGQ" target="whole">
                    Five Animals of Shaolin - Crane
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/evzBa_Ne14I" target="whole">
                    Five Animals of Shaolin - Tiger
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/C8mcp0Sovc8" target="whole">
                    Five Animals of Shaolin - Dragon
                  </a>
                </li>
              </ul>
            </ul>
          </ul>
          <ul className="styled-list">
            <li>Taiji Quan 太極拳</li>

            <ul>
              <li>Taiji Quan Long Form </li>

              <ul>
                <li>
                  <a
                    href="http://www.youtube.com/watch?v=kEQ8sUn_ehQ"
                    target="whole"
                  >
                    {" "}
                    Taiji Quan Form (Section 1){" "}
                  </a>
                </li>
                <li>
                  <a
                    href="http://www.youtube.com/watch?v=7S1DY5Fzbp0"
                    target="whole"
                  >
                    {" "}
                    Taiji Quan Form (Section 2.1)
                  </a>
                </li>
                <li>
                  <a
                    href="http://www.youtube.com/watch?v=5VJ34kfiXLg"
                    target="whole"
                  >
                    {" "}
                    Taiji Quan Form (Section 2.2)
                  </a>
                </li>
                <li>
                  <a
                    href="http://www.youtube.com/watch?v=mLbBz8ycTlI"
                    target="whole"
                  >
                    {" "}
                    Taiji Quan Form (Section 3.1)
                  </a>
                </li>
                <li>
                  <a
                    href="http://www.youtube.com/watch?v=rQzvGUuEDa4"
                    target="whole"
                  >
                    {" "}
                    Taiji Quan Form (Section 3.2)
                  </a>
                </li>
              </ul>
              <li>Taiji Quan short form</li>
              <ul>
                <li>
                  <a href="https://youtu.be/wZYDEYvv9Zs" target="whole">
                    {" "}
                    Taiji Quan - Chen Wei Ming Style Short Form
                  </a>
                </li>
              </ul>
              <li>Taiji Quan Fighting Drills (two person drills)</li>
              <ul>
                <li>
                  <a href="https://youtu.be/Tsc98YZdcMs" target="whole">
                    Taiji Quan Push Hands - Single hand
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/dtR2KlaAQi4" target="whole">
                    Taiji Quan Push Hands - Stepping Drills
                  </a>
                </li>

                <li>
                  <a href="https://youtu.be/sH_CUaGkXcA" target="whole">
                    Taiji Quan Push Hands - Low Stance #1
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/fkqFLhvX2Nk" target="whole">
                    Taiji Quan Push Hands - Low Stance #2
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/Yrrm7uNLd9o" target="whole">
                    Taiji Quan Push Hands - Low Stance #3
                  </a>
                </li>

                <li>
                  <a href="https://youtu.be/7tXu4eJdDxk" target="whole">
                    Taiji Quan Push Hands - combined
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=7WDCXXidzD0"
                    target="whole"
                  >
                    {" "}
                    Taiji Quan - San Shou Form
                  </a>
                </li>
              </ul>
              <li>Weapon Forms</li>
              <ul>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=3Dmq7gTLkUU"
                    target="whole"
                  >
                    {" "}
                    Taiji Quan - Wutang Sword Form
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=xbCTOWdQRns"
                    target="whole"
                  >
                    {" "}
                    Taiji Quan - Wutang Sword Form (two person drills)
                  </a>
                </li>
              </ul>
            </ul>
          </ul>
          <ul className="styled-list">
            <li>Xingyi Quan - 形意拳 </li>
            <ul>
              <li>Five Elements - empty hand</li>
              <ul>
                <li>
                  {" "}
                  <a href="https://youtu.be/GxRZyiXJnos" target="whole">
                    XingYi - Pi Chuan (metal - splitting)
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/bpZ2txXd1-M" target="whole">
                    XingYi - Tsuan Chuan (water - drilling)
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/2MxAo9Ynzmo" target="whole">
                    XingYi - Peng Chuan (wood - crushing)
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/GFsmp_M3Wtc" target="whole">
                    XingYi - Pao Chuan (fire - pounding)
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/22KK4h0SJD0" target="whole">
                    XingYi - Heng Chuan (earth - crossing)
                  </a>
                </li>
              </ul>
              <li>Five Elements - sword</li>
              <ul>
                <li>
                  {" "}
                  <a href="https://youtu.be/5OatioBub7Q" target="whole">
                    XingYi Sword - Pi Chuan (metal - splitting)
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/727kue0qvTU" target="whole">
                    XingYi Sword - Tsuan Chuan (water - drilling){" "}
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/GW59-FcRzGI" target="whole">
                    XingYi Sword - Peng Chuan (wood - crushing){" "}
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/wYA0j-sokV0" target="whole">
                    XingYi Sword - Pao Chuan (fire - pounding){" "}
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/bgwnxXlUpus" target="whole">
                    XingYi Sword - Heng Chuan (earth - crossing){" "}
                  </a>
                </li>
              </ul>
              <li>Linking forms</li>
              <ul>
                <li>
                  {" "}
                  <a href="https://youtu.be/w6zJBShsKaU" target="whole">
                    XingYi - Linking 5
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/lCF0sZqGTBQ" target="whole">
                    XingYi - Linking 8{" "}
                  </a>
                </li>
              </ul>

              <li>Fighting Drills (two person drills)</li>
              <ul>
                <li>
                  {" "}
                  <a href="https://youtu.be/FIraWn9XWN0" target="whole">
                    XingYi Fighting - Linking 3 Elements
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/1iI6UI8V7tk" target="whole">
                    XingYi Fighting - Linking 5 Elements
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/VnYwDJsc3UI" target="whole">
                    XingYi Fighting - Linking 3 Elements (stationary){" "}
                  </a>
                </li>
              </ul>

              <li>Animals</li>
              <ul>
                <li>
                  {" "}
                  <a href="https://youtu.be/iRNZm5OLtyI" target="whole">
                    XingYi - Falcon{" "}
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/2B62E1vg9rU" target="whole">
                    XingYi - Swallow
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/QVTBNAhlreE" target="whole">
                    XingYi - Rooster
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/KnZsWxMHQw8" target="whole">
                    XingYi - Dove{" "}
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/C4JGijC8pU8" target="whole">
                    XingYi - Snake{" "}
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/5QTDCcN-wXM" target="whole">
                    XingYi - Tiger
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/YIWUXjl-xqE" target="whole">
                    XingYi - Eagle & Bear{" "}
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/F-wP31bnuMA" target="whole">
                    XingYi - Turtle
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/cfx5o84C15o" target="whole">
                    XingYi - Horse
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/6VoPlT_zPtQ" target="whole">
                    XingYi - Monkey{" "}
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://youtu.be/wbJSoF3mzpw" target="whole">
                    XingYi - Dragon{" "}
                  </a>
                </li>
              </ul>

              <li>Linking forms</li>
              <ul>
                <li>
                  {" "}
                  <a href="https://youtu.be/vLhxKGznzXU" target="whole">
                    XingYi - Linking Animals{" "}
                  </a>
                </li>
              </ul>

              <li>Fighting Drills (two person drills)</li>
              <ul>
                <li>
                  {" "}
                  <a href="https://youtu.be/zAQFNlFr3DA" target="whole">
                    XingYi Fighting - Animals{" "}
                  </a>
                </li>
              </ul>
            </ul>
          </ul>
          <ul className="styled-list">
            <li>Qigong 氣功</li>
            <ul>
              <li>Dragon Bagua Zhang</li>
              <ul>
                <li>
                  {" "}
                  <a href="https://youtu.be/mrBpVZbZYhA" target="whole">
                    {" "}
                    Yin Style Baguazhang 八卦掌 - Foundational Qigong
                  </a>
                </li>
              </ul>

              <li>Northstar Qigong</li>
              <ul>
                <li> coming soon...</li>
              </ul>

              <li>Huashan Qigong</li>
              <ul>
                <li>
                  {" "}
                  <a href="https://youtu.be/KNvo4anLBNQ" target="whole">
                    {" "}
                    Huashan Taoist Qigong
                  </a>
                </li>
              </ul>

              <li>White Crane Qigong</li>
              <ul>
                <li>
                  {" "}
                  <a href="https://youtu.be/310Vz0OBndw" target="whole">
                    {" "}
                    White Crane Qigong
                  </a>
                </li>
              </ul>
              {/* </div>
               */}
              <li>
                Muscle Sinew Washing Qigong 易筋經 (
                <a href="https://youtu.be/H2MT_3byG9Q" target="whole">
                  full video
                </a>
                )
              </li>
              <ul>
                <li>Beginning</li>
                <ul>
                  <li>
                    <a href="https://youtu.be/H2MT_3byG9Q?t=0" target="whole">
                      Introduction, Instructions & background
                    </a>
                  </li>
                </ul>
                <li>Part 1 - Stationary Exercises</li>

                <ul>
                  <li>
                    <a href="https://youtu.be/H2MT_3byG9Q?t=214" target="whole">
                      Caressing the ball in horse stance
                    </a>
                  </li>
                  <li>
                    <a href="https://youtu.be/H2MT_3byG9Q?t=300" target="whole">
                      Fisherman rowing the boat
                    </a>
                  </li>
                  <li>
                    <a href="https://youtu.be/H2MT_3byG9Q?t=365" target="whole">
                      Hitting the tree in horse stance
                    </a>
                  </li>
                  <li>
                    <a href="https://youtu.be/H2MT_3byG9Q?t=440" target="whole">
                      Cloud hands
                    </a>
                  </li>
                  <li>
                    <a href="https://youtu.be/H2MT_3byG9Q?t=660" target="whole">
                      Clutching eagle claws
                    </a>
                  </li>
                  <li>
                    <a href="https://youtu.be/H2MT_3byG9Q?t=771" target="whole">
                      Scholar opening the scroll
                    </a>
                  </li>
                  <li>
                    <a href="https://youtu.be/H2MT_3byG9Q?t=869" target="whole">
                      Young boy worshipping Buddha
                    </a>
                  </li>
                  <li>
                    <a href="https://youtu.be/H2MT_3byG9Q?t=970" target="whole">
                      The butterfly
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=1063"
                      target="whole"
                    >
                      Crouching tiger
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=1275"
                      target="whole"
                    >
                      Squatting and lifting
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=1402"
                      target="whole"
                    >
                      The swimming snake
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=1531"
                      target="whole"
                    >
                      Extend the waist to view the moon
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=1665"
                      target="whole"
                    >
                      The swallow returns to the nest
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=1787"
                      target="whole"
                    >
                      The cat looking at the moon
                    </a>
                  </li>
                </ul>

                <li>Part 2 - Moving Exercises</li>

                <ul>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=1962"
                      target="whole"
                    >
                      Raising the flag
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=2076"
                      target="whole"
                    >
                      Elbows pushing in the cross step
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=2150"
                      target="whole"
                    >
                      The general taking off his boots
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=2303"
                      target="whole"
                    >
                      Monkey lifts cauldron
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=2380"
                      target="whole"
                    >
                      Monkey leaping in air
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=2447"
                      target="whole"
                    >
                      Monkey stretch
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=2496"
                      target="whole"
                    >
                      Scanning the bottom of the sea in T stance
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=2573"
                      target="whole"
                    >
                      Crane stretch
                    </a>
                  </li>
                </ul>
                <li>Part 3 - Meditation</li>

                <ul>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=2656"
                      target="whole"
                    >
                      Standing Meditation
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtu.be/H2MT_3byG9Q?t=2785"
                      target="whole"
                    >
                      Meditation Dispersal
                    </a>
                  </li>
                </ul>
              </ul>
            </ul>
          </ul>
          <ul className="styled-list">
            <li>Miscellaneous Form Footage</li>

            <ul>
              <li>Rare footage</li>
              <ul>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=7iw99rgFquo"
                    target="whole"
                  >
                    Kwan Sai Hung - crica 1994{" "}
                  </a>
                </li>
                <li>
                  <a href="https://youtu.be/f5Xy579B5eA" target="whole">
                    Brent Hamby - Sanda demo{" "}
                  </a>
                </li>
              </ul>
            </ul>
            <ul>
              <li>EBM Kung Fu Public Demo</li>
              <ul>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=lr7K6XDeexw"
                    target="whole"
                  >
                    Shaolin #5{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=M6xYcRo5yBo"
                    target="whole"
                  >
                    XingYi sword{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=R7AMm77w2LE"
                    target="whole"
                  >
                    {" "}
                    XingYi 5 elements{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=iLEOWJMfj4o"
                    target="whole"
                  >
                    {" "}
                    Taiji Quan two person sword form{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=Efk5eJrY-b0"
                    target="whole"
                  >
                    {" "}
                    Wu tang broadsword{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=LwUrMwFqU8E"
                    target="whole"
                  >
                    {" "}
                    Advanced shaolin spear{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=6eI6GApc_2g"
                    target="whole"
                  >
                    {" "}
                    Taiji Quan San Shou (two person){" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=aklimCwBWhk"
                    target="whole"
                  >
                    {" "}
                    Two person shaolin tan tui{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=Ih1no7wUC2g"
                    target="whole"
                  >
                    {" "}
                    Northern Shaolin double sword{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=aklimCwBWhk"
                    target="whole"
                  >
                    {" "}
                    Tan Tui Fighting Form{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=TPV-PTHydiY"
                    target="whole"
                  >
                    {" "}
                    Taiji Quan push hands{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=61mgKv3n988"
                    target="whole"
                  >
                    {" "}
                    XingYi Fighting Form{" "}
                  </a>
                </li>
              </ul>
            </ul>
            <ul>
              <li>Wong Jack Man - Oakland class footage </li>
              <ul>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=li_r12nAj80"
                    target="whole"
                  >
                    {" "}
                    XingYi Fighting Form{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=bdOfZ-oLqX0"
                    target="whole"
                  >
                    {" "}
                    Taiji Quan San Shou (two person){" "}
                  </a>
                </li>
              </ul>
            </ul>
          </ul>
        </>
      ) : (
        "please log in"
      )}
    </div>
  );
}

export default Library;
